/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPercentage90 = createReactComponent("outline", "percentage-90", "IconPercentage90", [["path", { "d": "M12 3a9 9 0 1 1 -5.16 1.626l5.16 7.374z", "fill": "currentColor", "stroke": "none", "key": "svg-0" }], ["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-1" }]]);

export { IconPercentage90 as default };
//# sourceMappingURL=IconPercentage90.mjs.map
